import { render, staticRenderFns } from "./CreateFmgModal.vue?vue&type=template&id=0509f8a6&scoped=true"
import script from "./CreateFmgModal.vue?vue&type=script&lang=ts"
export * from "./CreateFmgModal.vue?vue&type=script&lang=ts"
import style0 from "./CreateFmgModal.vue?vue&type=style&index=0&id=0509f8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0509f8a6",
  null
  
)

export default component.exports